import { decamelizeKeys } from 'humps'

/** @enum {MailChimpListIds} */
/** @typedef {String} MailChimpListIds */
export const MAIL_CHIMP_LIST_IDS = {
  SHAPA_SUBSCRIBERS_LIST: "d12776e447"
};

/** @enum {MailChimpTagsList} */
/** @typedef {String} MailChimpTagsList */
export const MAIL_CHIMP_TAGS = {
  ABANDONED_CART_TAG: "abandoncart"
};


/** @enum {MailChimpTagsStatus} */
/** @typedef {String} MailChimpTagsStatus */
export const MAIL_CHIMP_TAGS_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

export default {
  /**
   * Save an email address to a given Mailchimp list.
   * @param {String} emailAddress
   * @param {MailChimpListIds} listId
   * @param {MailChimpTagsList} tag
   * @returns {Promise}
   */
  saveEmailAddressToList(emailAddress, listId, tag = null) {
    // Since we are making a request to a non-API JSON action, we need a CSRF token.
    const csrfToken = document.querySelector('[name=csrf-token]').content;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/email_collection/save_email_address_to_list",
        type: "POST",
        dataType: "text",
        data: decamelizeKeys({
          authenticityToken: csrfToken,
          email: emailAddress,
          listId,
          tag
        }),
        success: response => resolve(response),
        error: response => reject(response.responseText)
      });
    });
  },

  /**
   * Remove an email address from a given Mailchimp list.
   * @param {String} emailAddress
   * @param {MailChimpListIds} listId
   * @returns {Promise}
   */
  removeEmailAddressFromList(emailAddress, listId) {
    // Since we are making a request to a non-API JSON action, we need a CSRF token.
    const csrfToken = document.querySelector('[name=csrf-token]').content;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/email_collection/remove_user_from_list",
        type: "POST",
        dataType: "text",
        data: decamelizeKeys({
          authenticityToken: csrfToken,
          email: emailAddress,
          listId
        }),
        success: response => resolve(response),
        error: response => reject(response.responseText)
      });
    });
  },

  /**
   * Update a tag status for the given email address and Mailchimp list.
   * This method allows a developer to add or remove a Mailchimp tag.
   * @param {String} emailAddress
   * @param {MailChimpListIds} listId
   * @param {MailChimpTagsList} tag
   * @param {MailChimpTagsStatus} status
   * @returns {Promise}
   */
  updateUserTag(emailAddress, listId, tag, status = MAIL_CHIMP_TAGS_STATUS.ACTIVE) {
    // Since we are making a request to a non-API JSON action, we need a CSRF token.
    const csrfToken = document.querySelector('[name=csrf-token]').content;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/email_collection/update_user_tag",
        type: "POST",
        dataType: "text",
        data: decamelizeKeys({
          authenticityToken: csrfToken,
          email: emailAddress,
          listId,
          tag,
          status
        }),
        success: response => resolve(response),
        error: response => reject(response.responseText)
      });
    });
  }
}